import { Turbo } from "@hotwired/turbo-rails"

Turbo.StreamActions.visit = function () {
  const url = this.getAttribute("target")
  if (url) Turbo.visit(url)
}
